import { runMingo, unFlatten } from '@buddy-technology/ion-helpers';
import { useWatch } from 'react-hook-form';

const generateDynamicOptions = ({
	dynamicOptionLabels, getValues, variables, control, offeringOptions,
}) => {
	const valuesToWatch = dynamicOptionLabels?.fieldsToWatch ? dynamicOptionLabels?.fieldsToWatch.map((_label) => _label.replace(/\$/g, '').replace(/\./g, '::')) : [];

	const watchedValues = useWatch({ control, name: valuesToWatch });

	if (dynamicOptionLabels?._calculate) {
		const state = getValues();
		const { value: mingoValue, error } = runMingo(dynamicOptionLabels._calculate, { ...unFlatten(state), variables, offeringOptions });
		if (error) {
			// eslint-disable-next-line no-console
			console.error(`Problem calculating dynamic option labels: ${error}`);
			return [];
		}

		// make sure mingoValue is an array
		if (!Array.isArray(mingoValue)) {
			if (typeof window !== 'undefined' && window.Sentry) {
				window.Sentry.withScope((scope) => {
					scope.setTags({
						rejectionType: 'generateDynamicOptions',
						mingoValue,
					});
					window.Sentry.captureException(`mingoValue should be an array, but got: ${JSON.stringify(mingoValue)}`);
				});
			}
			// eslint-disable-next-line no-console
			console.error('mingoValue should be an array, but got:', mingoValue);
		}

		const dynamicOptionsToRender = mingoValue?.reduce((acc, _item) => {
			const { value, label } = _item;
			if (label && value && label !== '' && value !== '') {
				// We serialize our watched values here and make that part of the key.
				// This ensures that if state changes our option, we can get around a react hook form bug preventing input state updates if an option disappears after it was selected.
				acc.push({ ..._item, key: `${label}-${value}-${watchedValues.join()}` });
			}
			return acc;
		}, []);

		return dynamicOptionsToRender;
	}
	return [];
};

export default generateDynamicOptions;
